export default __webpack_public_path__ + "static/media/no_select.063117e5.svg";